export default "<div [class]=\"icon\">\n  <SvgIcon [icon]=\"icon\"></SvgIcon>\n  <span *ngIf=\"title\">{{title}}</span>\n</div>\n"